import JinjaIcon from "@/assets/JinjaIcon";
import HelpTooltip from "@/components/ui/HelpTooltip";
import { observer } from "mobx-react-lite";
import { useSchemaEditor } from ".";
import { usePlayground } from "../Playground2/playground-store";

const JinjaHelpTooltip = ({
  onConfirmFormat,
}: {
  onConfirmFormat: () => void;
}) => {
  const { isUsingJinja } = useSchemaEditor();
  try {
    usePlayground();
    return (
      <HelpTooltip
        content={
          isUsingJinja
            ? "Use {{variable}} to dynamically inject values"
            : "Click here to update template format to `jinja2`"
        }
        onClick={!isUsingJinja ? onConfirmFormat : undefined}
        icon={<JinjaIcon empty={!isUsingJinja} />}
      />
    );
  } catch (e) {
    return null; // Don't render if there is no valid playground context.
  }
};

export default observer(JinjaHelpTooltip);
